import { autoinject, bindable } from 'aurelia-framework';
import { CreateAnalysisCompanyDto } from 'models/AnalysisCompany';
import { ValidationController, ValidationRules, Validator } from 'aurelia-validation';
import { I18N } from 'aurelia-i18n';
import { AnalysisCompanyService, ToastService } from 'services';

@autoinject
export class AnalysisCompanyNew {
  private analysisCompany: CreateAnalysisCompanyDto = new CreateAnalysisCompanyDto();
  private saving: boolean = false;

  @bindable()
  onAnalysisCompanyCreated?: ({ analysisCompanyId }: { analysisCompanyId: number }) => void;

  constructor(
    private i18n: I18N,
    private validationController: ValidationController,
    private analysisCompanyService: AnalysisCompanyService,
    private toastService: ToastService
  ) {
    ValidationRules.ensure('Name').required().withMessage(i18n.tr('general.requiredField')).on(this.analysisCompany);
  }

  private async createAnalysisCompany() {
    this.saving = true;
    const result = await this.validationController.validate({ object: this.analysisCompany });
    if (result.valid) {
      const { IsDuplicate } = await this.analysisCompanyService.checkDuplicate({ Name: this.analysisCompany.Name });

      if (IsDuplicate) {
        this.toastService.showWarning(this.i18n.tr('general.analysisCompanyDuplicate'));
      } else {
        const { AnalysisCompanyId } = await this.analysisCompanyService.createAnalysisCompany(this.analysisCompany);
        this.onAnalysisCompanyCreated?.({ analysisCompanyId: AnalysisCompanyId });
      }
    }
    this.saving = false;
  }
}
